export const ASYNC_CREATE_PROFILE = 'ASYNC_CREATE_PROFILE';
export const ASYNC_EDIT_PROFILE = 'ASYNC_EDIT_PROFILE';
export const ASYNC_DELETE_PROFILE = 'ASYNC_DELETE_PROFILE';
export const ASYNC_RESTORE_PROFILE = 'ASYNC_RESTORE_PROFILE';
